const PREFIX = "coupon-listing-text-banner";

export const COUPON_TEXT_BANNER_DATA_TEST_ID = {
    CONTAINER: `${PREFIX}-container`,
    IMAGE: `${PREFIX}-image`,
    TEXT: `${PREFIX}-text`,
};
